(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-backstube"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Backstube');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-brauerei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Brauerei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-buchbinderei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Buchbinderei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-druckerei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Druckerei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-faerberei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Faerberei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-gerberei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Gerberei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-glashuette"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Glashuette');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-goldschmiede"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Goldschmiede');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-hutmacher"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Hutmacher');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-kueferei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Kueferei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-metzgerei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Metzgerei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-muehle"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Muehle');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-sattlerei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Sattlerei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-schlosserei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Schlosserei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-schmiede"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Schmiede');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-schneiderei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Schneiderei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-schuhmacherei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Schuhmacherei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-seilerei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Seilerei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-steinmetz"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Steinmetz');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-stellmacherei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Stellmacherei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-tischlerei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Tischlerei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-toepferei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Toepferei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-uhrmacherei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Uhrmacherei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-weberei"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.getElementById('HW-Weberei');
    if (!root || root.dataset.navigationReady) return;
    root.dataset.navigationReady = 'true';
    const links = [...root.querySelectorAll('.zb-toc__nav a')];
    const chapters = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(item => item.target);
    const header = document.querySelector('.section-header');
    const updateOffset = () => root.style.setProperty('--hw-header-offset', Math.max(82, (header?.getBoundingClientRect().height || 68) + 14) + 'px');
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    let queued = false;
    const update = () => {
      queued = false;
      const limit = parseFloat(getComputedStyle(root).getPropertyValue('--hw-header-offset')) + 100;
      const ordered = [...chapters].sort((a,b) => a.target.offsetTop - b.target.offsetTop);
      let active = ordered[0];
      for (const item of ordered) if (item.target.getBoundingClientRect().top <= limit) active = item;
      for (const item of chapters) {
        if (item === active) item.link.setAttribute('aria-current','location');
        else item.link.removeAttribute('aria-current');
      }
    };
    window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(update);}}, {passive:true});
    window.addEventListener('resize', updateOffset, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materiallexikon"]) return;
  try {
    
function initMaterialOverview(){document.querySelectorAll('.mw-overview').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const grid=root.querySelector('.mw-grid'),cards=[...grid.children],search=root.querySelector('[data-mw-search]'),category=root.querySelector('[data-mw-category]'),sort=root.querySelector('[data-mw-sort]');function apply(){const term=search.value.trim().toLocaleLowerCase('de');let count=0;cards.sort((a,b)=>(sort.value==='za'?-1:1)*a.dataset.name.localeCompare(b.dataset.name,'de')).forEach(card=>{card.hidden=!(card.dataset.name.includes(term)&&(!category.value||card.dataset.category===category.value));if(!card.hidden)count++;grid.append(card)});root.querySelector('[data-mw-status]').textContent=count+(count===1?' Material':' Materialien');root.querySelector('[data-mw-empty]').hidden=count!==0}search.addEventListener('input',apply);category.addEventListener('change',apply);sort.addEventListener('change',apply);apply()})}initMaterialOverview();document.addEventListener('shopify:section:load',initMaterialOverview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schulbibliothek-integration-v1"]) return;
  try {
    
/* Adds four existing topics to the original eight cards. No history interception,
   polling, mutation observers, network requests, or third-party storage. */
(() => {
  'use strict';
  if (window.ZBISchoolLibraryV1) { window.ZBISchoolLibraryV1.init(); return; }
  let state = null;
  const normalize = value => String(value || '').toLocaleLowerCase('de-DE')
    .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  const tokens = value => normalize(value).split(/\s+/).filter(Boolean);
  const matchToken = (value, selected) => !selected || tokens(value).includes(normalize(selected));
  const previewLink = a => {
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (!preview || !/^\d+$/.test(preview)) return;
    const u = new URL(a.getAttribute('href'), location.origin);
    if (u.origin !== location.origin || !u.pathname.includes('/pages/unterrichtsmaterial')) return;
    u.searchParams.set('preview_theme_id', preview);
    a.href = u.pathname + u.search + u.hash;
  };
  function destroy() {
    if (!state) return;
    const s = state; state = null;
    s.abort.abort();
    if (s.form.isConnected) s.form.replaceWith(s.oldForm);
    if (s.empty.isConnected) s.empty.replaceWith(s.oldEmpty);
    s.extra.forEach(card => card.remove());
    s.additions.forEach(node => node.remove());
    s.original.forEach(card => { card.hidden = false; });
    s.count.textContent = s.oldCount;
    s.count.removeAttribute('role'); s.count.removeAttribute('aria-live');
    if (s.hero) s.hero.textContent = s.oldHero;
    if (s.meta) s.meta.textContent = s.oldMeta;
    s.root.hidden = false;
    delete s.library.dataset.zbiAttached;
    // Let the original controls resume their own filtering if the integration is removed.
    const oldControl = s.oldForm.querySelector('input,select');
    if (oldControl && s.oldForm.isConnected) oldControl.dispatchEvent(new Event('input', {bubbles: true}));
  }
  function init() {
    const root = document.querySelector('[data-zbi-root]');
    const library = document.querySelector('.zda-school-page [data-zda-material-library]');
    if (state && state.root === root && state.library === library && library?.isConnected) {
      state.apply(); return;
    }
    if (state) destroy();
    if (!root || !library) return; // Four additions remain readable as fallback.
    const grid = library.querySelector('.zda-school-material-grid');
    const oldForm = library.querySelector('.zda-school-library-tools');
    const oldEmpty = library.querySelector('[data-zda-filter-empty]');
    const count = library.querySelector('[data-zda-result-count]');
    const source = root.querySelector('[data-zbi-extras]');
    const formTemplate = root.querySelector('template[data-zbi-form]');
    const emptyTemplate = root.querySelector('template[data-zbi-empty]');
    if (!grid || !oldForm || !oldEmpty || !count || !source || !formTemplate || !emptyTemplate) return;
    const original = Array.from(grid.querySelectorAll('[data-zda-material-card]'));
    if (original.length !== 8 || library.dataset.zbiAttached) return;
    const extra = Array.from(source.children).map(node => node.cloneNode(true));
    if (extra.length !== 4) return;
    const form = formTemplate.content.firstElementChild.cloneNode(true);
    const empty = emptyTemplate.content.firstElementChild.cloneNode(true);
    const controls = Object.fromEntries(Array.from(form.querySelectorAll('[data-zbi-filter]'))
      .map(node => [node.dataset.zbiFilter, node]));
    const abort = new AbortController(); const additions = [];
    const cards = original.concat(extra);
    const hero = document.querySelector('.zda-school-page .zda-school-stat-card--one strong');
    const meta = library.querySelector('.zda-school-library-meta > span');
    const oldCount = count.textContent, oldHero = hero?.textContent, oldMeta = meta?.textContent;
    let snapshot = [];
    const supplements = {"unterrichtsmaterial-was-ist-eine-zunft": "Wer regelt das Handwerk?", "unterrichtsmaterial-vom-lehrling-zum-meister": "Wie und wo wird gelernt?", "unterrichtsmaterial-die-walz": "Wissen teilen oder schützen?", "unterrichtsmaterial-zunftzeichen-und-bedeutung": "Ein Zeichen erklärt nicht alles", "unterrichtsmaterial-handwerk-damals-und-heute": "Reparieren oder neu herstellen?", "unterrichtsmaterial-welcher-handwerksberuf-passt": "Aus Interesse wird eine Prüffrage", "unterrichtsmaterial-werkzeuge-und-berufe": "Ein Werkzeug, mehrere Berufe", "unterrichtsmaterial-mittelalterliche-zunftstadt": "Unsere Stadt ist ein Modell"};
    const apply = () => {
      const q = tokens(controls.search.value);
      let visible = 0;
      snapshot.forEach(({card,text}) => {
        const ok = q.every(word => text.includes(word)) &&
          matchToken(card.dataset.grades, controls.grade.value) &&
          matchToken(card.dataset.subjects, controls.subject.value) &&
          matchToken(card.dataset.duration, controls.duration.value) &&
          matchToken(card.dataset.type, controls.type.value);
        card.hidden = !ok; if (ok) visible++;
      });
      count.textContent = `${visible} von ${cards.length} Themen gefunden`;
      empty.hidden = visible !== 0;
    };
    const reset = () => { form.reset(); apply(); controls.search.focus(); };
    form.addEventListener('submit', e => e.preventDefault(), {signal: abort.signal});
    form.addEventListener('input', apply, {signal: abort.signal});
    form.addEventListener('change', apply, {signal: abort.signal});
    form.querySelector('[data-zbi-reset]').addEventListener('click', reset, {signal: abort.signal});
    empty.querySelector('[data-zbi-reset]').addEventListener('click', reset, {signal: abort.signal});
    // Only swap the filter controls and append the four cards; keep old cards and their downloads.
    oldForm.replaceWith(form); oldEmpty.replaceWith(empty); grid.append(...extra);
    original.forEach(card => {
      const detail = card.querySelector('a[href*="/pages/unterrichtsmaterial-"]');
      const actions = card.querySelector('.zda-school-material__actions');
      if (!detail || !actions) return;
      const a = document.createElement('a');
      a.className = 'zda-school-button zda-school-button--text';
      const u = new URL(detail.getAttribute('href'),location.origin); u.hash='vertiefung';
      a.href=u.pathname+u.search+u.hash; a.textContent='Neu: Vertiefungsaufgabe und Unterrichtshilfen';
      const handle = u.pathname.split('/').pop();
      a.textContent = 'Vertiefung: ' + (supplements[handle] || 'Aufgabe und Unterrichtshilfen');
      a.dataset.zbiAdded='true'; actions.append(a); additions.push(a);
    });
    snapshot = cards.map(card => ({card, text: normalize(card.textContent + ' ' + (card.dataset.search || ''))}));
    library.querySelectorAll('a[href]').forEach(previewLink);
    count.setAttribute('role','status'); count.setAttribute('aria-live','polite');
    if (hero) hero.textContent=String(cards.length);
    if (meta) meta.textContent='12 Themen · 8 Basismodule mit zusätzlicher Online-Vertiefung';
    state={root,library,grid,original,extra,additions,form,empty,oldForm,oldEmpty,count,
      oldCount,hero,oldHero,meta,oldMeta,abort,apply};
    library.dataset.zbiAttached='true'; root.hidden=true; apply();
  }
  window.ZBISchoolLibraryV1={init,destroy};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  window.addEventListener('pageshow',()=>{ if(state) state.apply(); else init(); });
  document.addEventListener('shopify:section:unload',e=>{
    if(state && e.target instanceof Element && (e.target.contains(state.root)||e.target.contains(state.library))) destroy();
  });
  document.addEventListener('shopify:section:load',e=>{
    if(e.target instanceof Element && (e.target.querySelector('[data-zbi-root]')||e.target.querySelector('[data-zda-material-library]'))) init();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schule-pdf-downloads-v3"]) return;
  try {
    
(function(){
  'use strict';
  function repair(){
    const sources=new Map();
    document.querySelectorAll('[data-zpd-root] a[data-zpd-key][download]').forEach(a=>{
      if(a.getAttribute('href').startsWith('data:application/pdf;base64,JVBERi0'))sources.set(a.dataset.zpdKey,a);
    });
    if(!sources.size)return;
    document.querySelectorAll('button[data-zda-pdf]').forEach(button=>{
      const source=sources.get(button.dataset.zdaPdf);
      if(!source)return;
      const link=document.createElement('a');
      link.className=button.className;
      link.href=source.href;
      link.download=source.download;
      link.setAttribute('data-zpd-repaired',button.dataset.zdaPdf);
      if(button.hasAttribute('aria-label'))link.setAttribute('aria-label',button.getAttribute('aria-label'));
      while(button.firstChild)link.appendChild(button.firstChild);
      button.replaceWith(link);
    });
  }
  if(window.ZPDNativeDownloadsV3){window.ZPDNativeDownloadsV3();return;}
  window.ZPDNativeDownloadsV3=repair;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',repair,{once:true});else repair();
  document.addEventListener('shopify:section:load',repair);
  window.addEventListener('pageshow',repair);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schulmaterial-vertiefung-v1"]) return;
  try {
    
(()=>{'use strict';function init(){const root=document.querySelector('[data-zv-section]');if(!root)return;const panel=document.querySelector('.zda-school-detail .zda-school-download-panel');if(panel&&!panel.querySelector('[data-zv-jump]')){const link=document.createElement('a');link.href='#vertiefung';link.className='zv-jump';link.dataset.zvJump='true';link.textContent='Neu: Vertiefungsaufgabe und Unterrichtshilfen';panel.append(link);}const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview&&/^\d+$/.test(preview)){document.querySelectorAll('[data-zv-back],.zda-school-detail a[href*="/pages/unterrichtsmaterial"]').forEach(a=>{const u=new URL(a.getAttribute('href'),location.origin);if(u.origin!==location.origin)return;u.searchParams.set('preview_theme_id',preview);a.href=u.pathname+u.search+u.hash;});}}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zunftlexikon-hub"] && !Shopify.designMode) return;
  try {
    
function initZunftHub(){document.querySelectorAll('[id^="LexikonHub-"]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const videoWrap=root.querySelector('[data-zlh-video-wrap]');if(videoWrap){const video=videoWrap.querySelector('video');const playButton=videoWrap.querySelector('[data-zlh-video-play]');if(video&&playButton){const resetVideo=()=>{video.pause();video.currentTime=0;playButton.classList.remove('is-hidden');};playButton.addEventListener('click',()=>{playButton.classList.add('is-hidden');const playback=video.play();if(playback&&typeof playback.catch==='function'){playback.catch(()=>playButton.classList.remove('is-hidden'));}});video.addEventListener('ended',resetVideo);}}const input=root.querySelector('[data-hub-search]');if(!input)return;input.closest('label').hidden=false;root.querySelectorAll('a[href="#fachvertiefungen"]').forEach(a=>a.addEventListener('click',()=>{root.querySelector('#fachvertiefungen details').open=true;}));const cards=[...root.querySelectorAll('[data-hub-card]')];const normalize=s=>s.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g,'');input.addEventListener('input',()=>{const q=normalize(input.value.trim());let count=0;cards.forEach(card=>{card.hidden=!normalize(card.textContent).includes(q);if(!card.hidden)count++});root.querySelector('[data-hub-empty]').hidden=count>0;});});}
const oldChapter = /^#kapitel-chapter_0[1-8]$/.test(window.location.hash);if(oldChapter){const link=document.querySelector('.zlh-card:nth-child(2) a');if(link)window.location.replace(link.href+window.location.hash);}
initZunftHub();document.addEventListener('shopify:section:load',initZunftHub);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zunftlexikon-overview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zunftlexikon-overview')) {
  customElements.define('zunftlexikon-overview', class extends HTMLElement {
    connectedCallback() {
      if (this.zloController) return;
      this.zloController = new AbortController();
      const options = {signal: this.zloController.signal};
      const input = this.querySelector('[data-zlo-search]');
      const status = this.querySelector('[data-zlo-status]');
      const empty = this.querySelector('[data-zlo-empty]');
      const toggle = this.querySelector('[data-zlo-toggle]');
      if (!input || !status || !empty || !toggle) return;
      const groups = Array.from(this.querySelectorAll('[data-zlo-group]'));
      const normal = value => String(value || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
      const cards = Array.from(this.querySelectorAll('[data-zlo-card]')).map(card => ({
        node: card,
        text: normal(card.querySelector('[data-zlo-title]').textContent + ' ' + card.querySelector('[data-zlo-description]').textContent + ' ' + card.dataset.zloKeywords),
        details: card.querySelector('[data-zlo-details]'),
        items: Array.from(card.querySelectorAll('[data-zlo-subitem]')).map(item => ({node: item, text: normal(item.textContent)}))
      }));
      let savedOpen = null;
      const syncToggle = () => {
        const visible = cards.filter(card => !card.node.hidden && card.details);
        toggle.disabled = !visible.length;
        const text = visible.length && visible.every(card => card.details.open) ? 'Alle Unterthemen schließen' : 'Alle Unterthemen öffnen';
        if (toggle.textContent !== text) toggle.textContent = text;
      };
      const apply = () => {
        const tokens = normal(input.value).trim().split(/\s+/).filter(Boolean);
        if (tokens.length && savedOpen === null) savedOpen = new Map(cards.filter(card => card.details).map(card => [card.details, card.details.open]));
        let visible = 0;
        cards.forEach(card => {
          const baseMatch = tokens.every(token => card.text.includes(token));
          let itemMatch = false;
          card.items.forEach(item => {
            const matches = baseMatch || tokens.every(token => (card.text + ' ' + item.text).includes(token));
            item.node.hidden = !matches;
            if (matches) itemMatch = true;
          });
          card.node.hidden = !(baseMatch || itemMatch);
          if (!card.node.hidden) visible += 1;
          if (card.details && tokens.length) card.details.open = !card.node.hidden;
          if (card.details && !tokens.length && savedOpen) card.details.open = savedOpen.get(card.details) || false;
        });
        if (!tokens.length) savedOpen = null;
        groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-zlo-card]')).some(card => !card.hidden); });
        empty.hidden = visible !== 0;
        status.textContent = tokens.length ? visible + ' von ' + cards.length + ' Themenbereichen gefunden.' : 'Alle ' + cards.length + ' Themenbereiche werden angezeigt.';
        syncToggle();
      };
      const reset = () => { input.value = ''; apply(); };
      const openHashTarget = () => {
        const target = document.getElementById(window.location.hash.slice(1));
        if (target && this.contains(target)) {
          reset();
          const details = target.matches('details') ? target : target.querySelector('[data-zlo-details]');
          if (details) details.open = true;
        }
        const legacy = this.querySelector('[data-zlo-legacy]');
        if (legacy && /^#kapitel-chapter_0[1-8]$/.test(window.location.hash)) {
          legacy.hidden = false;
          legacy.querySelector('[data-zlo-chapter]').setAttribute('href', '/pages/zunftwissen-geschichte' + window.location.hash);
        }
      };
      input.addEventListener('input', apply, options);
      input.addEventListener('search', apply, options);
      this.querySelector('[data-zlo-reset]').addEventListener('click', () => {reset(); input.focus();}, options);
      this.querySelector('[data-zlo-jump]').addEventListener('click', event => {if (event.target.closest('a')) reset();}, options);
      toggle.addEventListener('click', () => {
        const visible = cards.filter(card => !card.node.hidden && card.details);
        const open = !visible.every(card => card.details.open);
        visible.forEach(card => {card.details.open = open;});
        syncToggle();
      }, options);
      cards.forEach(card => {if (card.details) card.details.addEventListener('toggle', syncToggle, options);});
      window.addEventListener('pageshow', apply, options);
      window.addEventListener('hashchange', openHashTarget, options);
      apply();
      openHashTarget();
      this.querySelector('[data-zlo-searchbox]').hidden = false;
      toggle.hidden = false;
    }
    disconnectedCallback() {
      if (this.zloController) this.zloController.abort();
      this.zloController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
